import EventEmitter from "events";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";

export default class AssetLoader extends EventEmitter {
  constructor(renderer) {
    super();
    const self = this;
    this.manager = new THREE.LoadingManager();

    this.manager.onProgress = (url, itemsLoaded, itemsTotal) => {
      /*
      console.log(
        "Loading file: " +
          url +
          ".\nLoaded " +
          itemsLoaded +
          " of " +
          itemsTotal +
          " files."
      );
      */
    };
    this.manager.onError = function(url) {
      // console.log("There was an error loading " + url);
    };
    this.manager.onLoad = function() {
      // console.log("self", self);
      self.assets.materials = self.initMaterials(self.assets, self.sceneData);
      self.emit("load", self.assets);
    };

    this.dracoLoader = new DRACOLoader(this.manager);
    this.dracoLoader.setDecoderPath("../draco/");
    this.dracoLoader.setDecoderConfig({ type: "js" });
    this.gltfLoader = new GLTFLoader(this.manager);
    this.gltfLoader.setDRACOLoader(this.dracoLoader);
    this.textureLoader = new THREE.TextureLoader(this.manager);

    this.assets = {};
    this.loaders = {
      model: (file, path) => {
        this.gltfLoader.load(path, gltf => {
          this.assets[file] = gltf;
        });
      },
      texture: (file, path) => {
        this.textureLoader.load(path, texture => {
          texture.flipY = false;
          this.assets[file] = texture;
        });
      },
      cubemap: (file, path) => {
        this.textureLoader.load(path, texture => {
          texture.mapping = THREE.EquirectangularReflectionMapping;
          this.assets[file] = texture;
        });
      }
    };
  }

  load(assets, data) {
    for (const file in assets.files) {
      const item = assets.files[file];
      this.loaders[item.type](file, item.path);
    }
    this.initMaterials = assets.initMaterials;
    this.sceneData = data;
  }
}
